export const getLoginRedirectPath = (state: string | null): string => {
  if (!state) return "/";

  try {
    const decoded = atob(state);
    if (!decoded.startsWith("/") || decoded.startsWith("//") || decoded.startsWith("/\\")) {
      return "/";
    }
    return decoded;
  } catch {
    return "/";
  }
};
